import type { BrowserTracker } from '@snowplow/browser-tracker';
import { newTracker, trackPageView, trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import getConfig from 'next/config';

import { logger } from 'Services/logger/logger';
import { isProd } from 'Utilities/helpers';

import { SNOWPLOW_SCHEMA_BASE_URL } from '../analytics/analytics.const';

import { PAGE_VIEW_EVENT_EXCLUDED_PATHS } from './snowplow.const';

const { publicRuntimeConfig } = getConfig();

export const initSnowplowTracker = ({
	isSnowplowMiniRedirect,
}: {
	isSnowplowMiniRedirect: boolean;
}): BrowserTracker | undefined => {
	const { SNOWPLOW_COLLECTOR_URL, SNOWPLOW_MINI_URL } = publicRuntimeConfig;

	const COLLECTOR_URL = isSnowplowMiniRedirect ? SNOWPLOW_MINI_URL : SNOWPLOW_COLLECTOR_URL;

	const tracker = newTracker('sp1', COLLECTOR_URL, {
		appId: `dealer-website-${isProd ? 'prod' : 'test'}`,
		cookieDomain: 'pro.motorway.co.uk',
		cookieSameSite: 'Lax',
		onSessionUpdateCallback() {
			setTimeout(() => {
				trackSelfDescribingEvent({
					event: {
						data: {},
						schema: `${SNOWPLOW_SCHEMA_BASE_URL}/new_session_start/jsonschema/1-0-0`,
					},
				});
			}, 0);
		},
		plugins: [],
	});

	if (!tracker) {
		logger.error({
			error: new Error('Failed to initialize Snowplow tracker'),
			message: 'Tracker initialization failed',
			scope: 'Snowplow init',
		});

		return undefined;
	}

	return tracker;
};

export const trackSnowplowPageView = (): void => {
	const { pathname, search } = window.location;
	const windowUrl = `${pathname}${search}`;

	if (PAGE_VIEW_EVENT_EXCLUDED_PATHS.includes(windowUrl)) {
		return;
	}

	trackPageView();
};
